(function ($) {
    // @ts-ignore
    function initFilter() {
        // on most ajax request the filter checkboxes get re-rendered, to reflect a maybe inactive state (to prevent 0 result lists...).
        // the checkboxes will be rendered hidden with the list and be moved to the final filter location afterwards.
        var reRenderedCheckboxes = $('#pjax-product-list .checkbox_wrapper');

        if (reRenderedCheckboxes.length) {
            $('#checkbox-filter-wrapper-placeholder')
                .html(reRenderedCheckboxes.detach().show())
                .find(':checkbox')
                .change(function () {
                    updateArticleList();
                });
        }

        // @ts-ignore
        $('.mobile .product_list .list_options .checkbox_wrapper').on('change', ':checkbox', function (event) {
            event.stopImmediatePropagation();
            var changed = false;

            // @ts-ignore
            if ($(this).is(':checked')) {
                // @ts-ignore
                changed = $(this).attr('id');
            }

            // @ts-ignore
            $(this)
                .closest('.checkbox_wrapper')
                .find(':checkbox')
                .each(function () {
                    // @ts-ignore
                    if ($(this).attr('id') === changed) {
                        // @ts-ignore
                        $(this).prop('checked', true);
                        // @ts-ignore
                        $('.list_filter #h' + $(this).attr('id')).prop('checked', true);
                    } else {
                        // @ts-ignore
                        $(this).prop('checked', false);
                        // @ts-ignore
                        $('.list_filter #h' + $(this).attr('id')).prop('checked', false);
                        if (changed) {
                            // @ts-ignore
                            $(this).parent().addClass('inactive');
                            // @ts-ignore
                            $(this).prop('disabled', true);
                        } else {
                            // @ts-ignore
                            $(this).parent().removeClass('inactive');
                            // @ts-ignore
                            $(this).prop('disabled', false);
                        }
                    }
                });

            updateArticleList();
        });

        // order by select box : TODO correct fields and order functionality
        $('.product_list .list_top select, .product_list .list_options .product_sorting select').change(function () {
            updateArticleList();
        });

        // Button "Weitere Artikel anzeigen" in der Artikel-Liste
        // @ts-ignore
        $('.product_gallery .list-link').on('click', 'a.button', function (event) {
            event.preventDefault();
            // @ts-ignore
            var link = $(this);
            link.addClass('loading');

            //add page to alternate meta tag
            var page = link.attr('href');

            var pageNum = parseInt(page.substring(page.indexOf('page=') + 5), 10);
            --pageNum;

            if (pageNum > 1) {
                page = '?page=' + pageNum;

                var all = document.querySelectorAll('link[rel="alternate"]');
                var oldhref;

                for (var i = 0; i < all.length; ++i) {
                    var linkNew = all[i];

                    // @ts-ignore
                    if (linkNew.href.indexOf('?page=') !== -1) {
                        // @ts-ignore
                        oldhref = linkNew.href.substr(0, linkNew.href.indexOf('?page='));
                    } else {
                        // @ts-ignore
                        oldhref = linkNew.href;
                    }

                    linkNew.setAttribute('href', oldhref + page);
                }
            }

            // @ts-ignore
            jQuery.get(link.attr('href'), function (data) {
                $('.product_gallery ul li:last').after(data['articles']);

                if (data['more_results_url']) {
                    link.attr('href', data['more_results_url']);
                } else {
                    link.remove();
                }

                link.removeClass('loading');
            });
        });

        var selects = document.querySelectorAll('select');
        // @ts-ignore
        customSelect.createSelect(selects);

        // @ts-ignore
        if (viewport === 'mobile') {
            // @ts-ignore
            var form = siteScripts.getEl('id', 'filter_form');
            // @ts-ignore
            var inputListAll = siteScripts.getEl('all', 'input', form);
            updateMobileFilterBar();
        } else {
            // @ts-ignore
            var form = siteScripts.getEl('sgl', '.product_list form .list_filter');
            // @ts-ignore
            var inputListAll = siteScripts.getEl('all', 'input[type=hidden], input[type=checkbox]', form);
        }

        // @ts-ignore
        var removeList = siteScripts.getEl('all', '.list_filter_result em');
        [].forEach.call(removeList, function (removeLink) {
            // @ts-ignore
            removeLink.addEventListener('click', function () {
                // @ts-ignore
                var val = this.parentNode.textContent;

                for (var i = 0; i < inputListAll.length; i++) {
                    if (inputListAll[i].value == val) {
                        if (inputListAll[i].type == 'checkbox') {
                            // uncheck checkbox
                            if (inputListAll[i].checked) {
                                inputListAll[i].checked = false;
                            }
                        } else {
                            // remove hidden inputs
                            inputListAll[i].parentNode.removeChild(inputListAll[i]);
                        }
                        break;
                    }
                }
                updateMobileFilterBar();
                updateArticleList();
            });
        });
    }

    function updateArticleList() {
        $('#filter_form').submit();
    }

    // @ts-ignore
    function updateFilters(id) {
        var form = $('#filter_form');
        form.removeData('pjax');

        var formData = form.serialize();
        // tell the server which filter was used, so the backend is able to render only a single context menu
        if (id) {
            formData = formData + '&active_filter=' + id;
        }

        // @ts-ignore
        if (viewport !== 'mobile') {
            $('form .list_filter').addClass('loading');
        }

        $.ajax({
            url: form.attr('action'),
            data: formData,
            // @ts-ignore
            success: function (data) {
                updateFilterHtml(data, id);
            },
            complete: function () {
                // @ts-ignore
                if (viewport !== 'mobile') {
                    $('form .list_filter').removeClass('loading');
                }
            },
        });
    }

    function updateMobileFilterBar() {
        var form = document.getElementById('filter_form');
        // @ts-ignore
        var inputListAll = form.querySelectorAll('input[type=checkbox], input[type=hidden]'),
            result = document.querySelector('.list_filter_result'),
            textList = [],
            total = '',
            skip_names = ['neu', 'sale', 'aktion', 'order_sort']; // These should never show up in the filter bar

        for (var i = 0; i < inputListAll.length; i++) {
            // @ts-ignore
            if (!skip_names.includes(inputListAll[i].name) && (inputListAll[i].checked || inputListAll[i].type === 'hidden')) {
                // @ts-ignore
                textList.push(inputListAll[i].value);
            }
        }

        if (textList.length) {
            // @ts-ignore
            result.style.display = 'block';
            for (var i = 0; i < textList.length; i++) {
                total = total + '<span>' + textList[i] + '<em></em></span>';
            }
            // @ts-ignore
            result.innerHTML = total;
        } else {
            // @ts-ignore
            result.innerHTML = '';
            // @ts-ignore
            result.style.display = 'none';
        }
    }

    // @ts-ignore
    function updateFilterHtml(data, id) {
        // @ts-ignore
        if (viewport === 'mobile') {
            var html_target = $('#' + id);
            html_target.html('');

            var html_source = $(data);
            var html_element = $('#' + id, html_source);
            var opener = html_element.find('a').clone();
            var new_content = html_element.find('.checkbox_wrapper').clone();

            html_target.append(opener);
            html_target.append(new_content);

            initFilter();
            initMobileFilter();

            if (id) {
                $('#filter_form .filter_box.active').each(function () {
                    // @ts-ignore
                    if ($(this).attr('id') != id) {
                        // @ts-ignore
                        $(this).find('.checkbox_wrapper').css('height', 0);
                        // @ts-ignore
                        $(this).find('.filter_opener.active').removeClass('active');
                        // @ts-ignore
                        $(this).removeClass('active');
                    }
                });

                var elem = $('#' + id);
                var opener = elem.find('.filter_opener');
                var filterDrop = elem.find('.checkbox_wrapper');

                let filterDropList = filterDrop.find('.input_holder');
                let filterDropHeight = 15;

                for (var i = 0; i < filterDropList.length; i++) {
                    filterDropHeight = filterDropHeight + filterDropList[i].offsetHeight + 6;
                }
                if (elem.hasClass('active')) {
                    filterDrop.css('height', '0');
                    opener.removeClass('active');
                    elem.removeClass('active');
                } else {
                    opener.addClass('active');
                    elem.addClass('active');
                    filterDrop.css('height', filterDropHeight + 'px');
                }
            }
        } else {
            $('form .list_filter .multi_wrapper').html(data);

            initFilter();
            multiSelectInit();

            if (id) {
                var elem = $('#' + id);
                elem.addClass('opened');

                var ttt = elem.find('p')[0];
                // @ts-ignore
                new SimpleBar(ttt.nextElementSibling);
            }
        }
    }

    // @ts-ignore
    function checkMultiselectSingle(item) {
        // @ts-ignore
        var inputList = siteScripts.getEl('all', 'input', item);
        /**
         * @type {boolean}
         */
        let selected = false;

        for (var i = 0; i < inputList.length; i++) {
            if (inputList[i].type == 'checkbox') {
                if (inputList[i].checked) {
                    selected = true;
                }
            } else if (inputList[i].value) {
                selected = true;
            }
        }

        if (selected) {
            item.classList.add('selected');
        } else {
            item.classList.remove('selected');
        }
    }

    function multiSelectInit() {
        // @ts-ignore
        if (viewport === 'mobile') {
            initMobileFilter();
        } else {
            initDesktopFilter();
        }
    }

    function initMobileFilter() {
        // multiselect
        // @ts-ignore
        [].forEach.call(siteScripts.getEl('all', '.filter_box'), function (multi) {
            // @ts-ignore
            multi.querySelector('.filter_opener').addEventListener('click', function (event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                // @ts-ignore
                updateFilters($(this).parent().attr('id'));
            });
        });

        // fetch article list with updated filters
        // @ts-ignore
        $('.list_filter .list_filter_inner :checkbox').change(function (event) {
            updateMobileFilterBar();
            updateArticleList();
        });
    }

    function initDesktopFilter() {
        //fetch article list with updated filters
        $('.product_list .list_filter .multi_wrapper :checkbox').change(function () {
            updateArticleList();
        });

        // multiselect
        // @ts-ignore
        [].forEach.call(siteScripts.getEl('all', '.multichoice'), function (multi) {
            checkMultiselectSingle(multi);

            // @ts-ignore
            multi.addEventListener('click', function (event) {
                event.stopImmediatePropagation();
            });

            // @ts-ignore
            multi.querySelector('p').addEventListener('click', function (event) {
                event.stopImmediatePropagation();

                // @ts-ignore
                if (this.parentNode.classList.contains('opened')) {
                    // @ts-ignore
                    this.parentNode.classList.remove('opened');
                } else {
                    // @ts-ignore
                    [].forEach.call(siteScripts.getEl('all', '.multichoice'), function (m) {
                        if ($(m).hasClass('opened')) {
                            // @ts-ignore
                            m.classList.remove('opened');
                        }
                    });

                    // @ts-ignore
                    updateFilters($(this).parent().attr('id'));
                }
            });
        });
    }

    function initInfiniteScrolling() {
        var moreArticlesButton = document.querySelector('#more_articles_button.infinite');
        if (moreArticlesButton) {
            // @ts-ignore
            let elmWithinViewport = function (el) {
                var rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            };

            // element already within the viewport -> fill the website to make the infinite scroll work
            if (elmWithinViewport(moreArticlesButton)) {
                // wait for event listeners beeing registered
                window.addEventListener('load', function () {
                    $('.product_gallery .list-link a.button').click();

                    // on really big screens the button might still be within the view.. load another chunk of products
                    setTimeout(function () {
                        if (elmWithinViewport(moreArticlesButton)) {
                            $('.product_gallery .list-link a.button').click();
                        }
                    }, 1000);
                });
            }

            // Element enters the viewport -> load the next chunk of products
            var intersectionObserver = new IntersectionObserver(
                function (entries) {
                    // Element enters the viewport
                    if (entries[0].intersectionRatio > 0) {
                        $('.product_gallery .list-link a.button').click();
                    }
                },
                {rootMargin: '250px 0px'},
            );

            intersectionObserver.observe(moreArticlesButton);
        }
    }

    $(document)
        // @ts-ignore
        .on('pjax:start', function (event) {
            var $pjaxRoot = $(event.target);
            $($pjaxRoot).addClass('pjax-container loading');
        })
        // @ts-ignore
        .on('pjax:end', function (event) {
            var $pjaxRoot = $(event.target);
            $($pjaxRoot).removeClass('loading');

            initFilter();
            initInfiniteScrolling();

            //DAIB2-1739
            // @ts-ignore
            dataLayer.push({event: 'pjax_pageview'});

            // @ts-ignore
            [].forEach.call(siteScripts.getEl('all', '.multichoice'), function (multi) {
                checkMultiselectSingle(multi);
            });

            //"reload" cms area
            $('div.product_list div.cms').html('');
        })
        .ready(function () {
            initFilter();
            initInfiniteScrolling();

            multiSelectInit();

            //klick auf document -> filter schliessen
            document.addEventListener('click', function () {
                // @ts-ignore
                [].forEach.call(siteScripts.getEl('all', '.multichoice'), function (multi) {
                    // @ts-ignore
                    if (multi.classList.contains('opened')) {
                        // @ts-ignore
                        multi.classList.remove('opened');
                    }
                });
            });
        });
    // @ts-ignore
})(jQuery);
